"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const text_field_styles_1 = require("./text-field-styles");
const tooltip_1 = require("../tooltip/tooltip");
const tooltip_field_hook_1 = require("../tooltip/tooltip-field-hook");
const auto_focus_hook_1 = require("../../utils/auto-focus-hook");
const compose_refs_1 = require("../../utils/compose-refs");
exports.TextField = react_1.forwardRef(function TextField({ form, id, name, onChange, disabled, value, onBlur, onFocus, onKeyDown, startAdornment, endAdornment, showClearButton = true, onClear, onChangeEvent, error = false, type = 'text', autocomplete, style = {}, inputProps, autoFocus, multiline = false, }, ref) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    value = value !== null && value !== void 0 ? value : '';
    const classes = text_field_styles_1.useStyles();
    const { withTooltip, tooltipRef } = tooltip_field_hook_1.useFieldTooltip(value);
    const { autoFocusRef } = auto_focus_hook_1.useAutoFocus(autoFocus, disabled);
    const inputRef = compose_refs_1.composeRefs(ref, tooltipRef, autoFocusRef);
    const handleClear = event_callback_hook_1.useEventCallback((e) => {
        var _a;
        if (onClear) {
            onClear(e);
        }
        e.stopPropagation();
        if (onChange !== undefined) {
            onChange(null);
        }
        (_a = autoFocusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    const handleChange = event_callback_hook_1.useEventCallback((e) => {
        if (onChangeEvent !== undefined) {
            onChangeEvent(e);
        }
        if (onChange !== undefined) {
            const value = e.target.value;
            onChange(value !== '' ? value : null);
        }
    });
    startAdornment = startAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, startAdornment));
    endAdornment = (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
        !disabled && !!value && showClearButton && type !== 'number' && (react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleClear, className: classes.icon, tabIndex: -1 },
            react_1.default.createElement(Clear_1.default, { fontSize: "small" }))),
        endAdornment && endAdornment));
    const content = (react_1.default.createElement(TextField_1.default, { InputProps: {
            classes: {
                root: classes.root,
                disabled: classes.disabled,
                input: classes.input,
            },
            style: {
                height: multiline ? 'auto' : '22px',
                padding: 0,
            },
            startAdornment,
            endAdornment,
        }, inputProps: {
            form,
            ...inputProps,
        }, inputRef: inputRef, className: clsx_1.default({ [classes.disabled]: disabled }), id: id, name: name, disabled: disabled, value: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, error: error, spellCheck: true, fullWidth: true, style: style, lang: "cs", type: type, autoComplete: autocomplete, multiline: multiline }));
    return withTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { title: value, placement: "top-start", type: "HOVER" }, content)) : (react_1.default.createElement(react_1.default.Fragment, null, content));
});
//# sourceMappingURL=text-field.js.map